import { COLORS, FONTS } from "../constants/theme";

// ─── LOGO ─────────────────────────────────────────────────────────────────────
// The RevCentriQ logo with the iQ styled in brand blue (#2563eb).
// Renders at three sizes: sm | md | lg
//
// Usage:
//   <Logo />              → medium (default)
//   <Logo size="sm" />    → small (footer, compact nav)
//   <Logo size="lg" />    → large (login page, CTA section)

const SIZES = {
  sm: { icon: 24, iconFont: 9, nameFont: 13, gap: 8, iconRadius: 6 },
  md: { icon: 30, iconFont: 11, nameFont: 16, gap: 10, iconRadius: 8 },
  lg: { icon: 64, iconFont: 22, nameFont: 36, gap: 16, iconRadius: 16 },
};

export default function Logo({ size = "md", style = {} }) {
  const s = SIZES[size];

  return (
    <div style={{ display: "flex", alignItems: "center", gap: s.gap, ...style }}>
      <div
        style={{
          width: s.icon,
          height: s.icon,
          borderRadius: s.iconRadius,
          background: `linear-gradient(135deg, ${COLORS.iqBlueDark}, ${COLORS.iqBlueMid})`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: FONTS.display,
          fontWeight: 800,
          fontSize: s.iconFont,
          letterSpacing: "-.02em",
          color: "#fff",
          flexShrink: 0,
        }}
      >
        iQ
      </div>
      <span
        style={{
          fontFamily: FONTS.display,
          fontWeight: 800,
          fontSize: s.nameFont,
          letterSpacing: "-.02em",
          color: COLORS.textPrimary,
          whiteSpace: "nowrap",
        }}
      >
        RevCentr<span style={{ color: COLORS.iqBlueMid }}>iQ</span>
      </span>
    </div>
  );
}
